import { $consentAtom } from '@client/core/atoms/consent.js';
import { Script } from '@client/core/utils/Script.js';
import {
  Brand,
  ConsentStatus,
  UNLEASH_FEATURE_NAME,
  type InitialState
} from '@schibsted-nmp/advertising-shared';

import { Helpers } from './Helpers.js';
import { Settings } from './Settings.js';

export namespace Scripts {
  export function* get(initialState: InitialState): get.ReturnValue {
    if (!isEnabled(initialState)) return;

    const parameters = Helpers.createParameters({
      ...initialState.config,
      consent: $consentAtom.get()
    });

    if (!parameters) return;

    const { brandConfig, path } = parameters;

    const accountId = Settings.get('accountId', brandConfig, path);

    if (!accountId) return;

    const tagName = Settings.get('tagName', brandConfig, path);

    if (!tagName) return;

    yield {
      name: 'relevant-digital-gam',
      src: `https://${accountId}-cdn.relevant-digital.com/static/tags/${tagName}.js`
    };
  }

  export namespace get {
    export type ReturnValue = Generator<Script, void, void>;
  }

  export function getServerHtml(initialState: InitialState) {
    if (!isEnabled(initialState)) return '';

    return Array.from(
      Script.getServerHtml(
        initialState,
        get,
        `<script>(()=>(window.relevantDigital??={}).cmd??=[])();</script>`
      )
    ).join('\n');
  }

  export function isEnabled({ unleashFeatures, config }: InitialState) {
    if (unleashFeatures[UNLEASH_FEATURE_NAME.killswitchPrebid]?.enabled) {
      return false;
    }

    if (!config.adServer.prebid) return false;

    // For non-DK brands we don't need user consent to enable GAM:
    const brandIsDanish = [Brand.Dba, Brand.Bilbasen].includes(config.brand);
    if (!brandIsDanish) return true;

    return $consentAtom.get() === ConsentStatus.Accepted;
  }
}
